import { ConstraintCoreBase } from "./constraint.core.base"


export class ConstraintCore extends ConstraintCoreBase {

}